export function productReviewDocId(orderId: string, productId: string): string {
  return `${orderId}__${productId}`
}

/** Unique id for admin-entered offline / in-store reviews (multiple per product). */
export function adminOfflineReviewDocId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return `offline__${crypto.randomUUID()}`
  }
  return `offline__${Date.now()}__${Math.random().toString(36).slice(2, 10)}`
}

/** Snap to nearest 0.5 between 1 and 5 (customer review input only). */
export function normalizeRating(value: number): number {
  if (!Number.isFinite(value)) return 0
  const snapped = Math.round(value * 2) / 2
  return Math.max(1, Math.min(5, snapped))
}

/** Format a stored product average for display — one decimal place. */
export function formatRatingValue(value: number): string {
  if (!Number.isFinite(value) || value <= 0) return '0'
  return (Math.round(value * 10) / 10).toFixed(1)
}

export function isProductReviewPublic(review: {
  approved?: boolean
  active?: boolean
}): boolean {
  return review.approved === true && review.active !== false
}
